import { Component, OnInit,ViewChild,ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '../../main-master/global.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  @ViewChild ('sliderContainer') sliderContainer:ElementRef;
  sliderContainerWidth:number;
  afterPrev:boolean = false;
  idInterval:any;
  slides = [
    {srcMobile:'../../../assets/images/slider1.jpg',srcDesc:'../../../assets/images/homeDesc.jpg',innerClass:'inner1',cssClass:'sl1',leftPosition:null, isTransition:false,title:"מעקב אחרי תעודות אחריות",content:"מכשיר התקלקל ואתם לא זוכרים איפה תעודת אחריות? האם היא עדיין בתוקף ואצל מי רכשתם את המוצר? אפליקציית אלקטריק ספייס מאפשרת לעקוב אחרי מוצרי חשמל הביתיים שלכם, לנהל תעודות אחריות. אין יותר צורך בשמירת חשבוניות ותעודות אחריות במגירה. ניתן להעלות את המסמכים לאפליקציה ובהתאם לצורך להדפיס  ולשלוח במייל או בוואטסאפ."},
    {srcMobile:'../../../assets/images/slider2.jpg',srcDesc:'../../../assets/images/homeDesc.jpg',innerClass:'inner1',cssClass:'sl2',leftPosition:null,isTransition:false,title:"קבלת התראות",content:"בבוא העת ניתן לקבל התראה אודות הטיפול הנדרש במוצר או פג תוקף האחריות"},
    {srcMobile:'../../../assets/images/slider3.jpg',srcDesc:'../../../assets/images/homeDesc.jpg',innerClass:'inner1',cssClass:'sl3',leftPosition:null,isTransition:false,title:"איתור מרכזי שירות",content:"שכחתם היכן רכשתם את המוצר ומי נותן שירותי תיקונים ותחזוקה? באפשרותכם לאתר בקלות את מרכזי השירות ותיקונים, אמצעי התקשרות עימם ושעות פעילות."},
    {srcMobile:'../../../assets/images/slider4.jpg',srcDesc:'../../../assets/images/homeDesc.jpg',innerClass:'inner1',cssClass:'sl4',leftPosition:null,isTransition:false,title:"דירוג מוצרים",content:"בכל עת ניתן לצפות בדירוג המוצר על ידי לקוחות אחרים, חוות דעתם בהתאם למאפייני המוצר וכמו כן להביע את רמת שביעות רצונכם מהשימוש בו."}
  ]
  

  constructor(private global:GlobalService) {
    this.startMooving()

   }

  ngOnInit(): void {
  }

  ngAfterViewInit(){

    setTimeout(()=>{
      this.sliderContainerWidth = this.sliderContainer.nativeElement.offsetWidth;
      console.log(this.sliderContainerWidth);
      this.getLeftPosition(-1)
    })
    

  }

  getLeftPosition(dir){
    for(let i =0; i<this.slides.length; i++){
      this.slides[i].leftPosition = this.sliderContainerWidth*i*dir; 
    }
  }

  prev(){
    clearInterval(this.idInterval);

    if(this.afterPrev){
        this.arrangeImges();
        this.getLeftPosition(-1)
        this.afterPrev = false;
    }

    setTimeout(()=>{
      this.slides.forEach((slide,index) =>{
        slide.isTransition = true
      }) 
  
      this.slides.forEach((slide,index) =>{
        slide.leftPosition += this.sliderContainerWidth;
      }) 

      
      setTimeout(()=>{
        this.slides.forEach((slide,index) =>{
          slide.isTransition = false
          
        })
        let el = this.slides.shift();
        this.slides.push(el);
        this.getLeftPosition(-1)
      
      },2000)

      this.startMooving()
      
    })

  }

  next(){
    clearInterval(this.idInterval);

    if(!this.afterPrev){
      this.arrangeImges();
      this.getLeftPosition(1)
      this.afterPrev = true;
    }

    setTimeout(()=>{
      this.slides.forEach((slide,index) =>{
        slide.isTransition = true
      }) 
  
      this.slides.forEach((slide,index) =>{
        slide.leftPosition -= this.sliderContainerWidth;
      }) 
      
  
      setTimeout(()=>{
        this.slides.forEach((slide,index) =>{
          slide.isTransition = false
          
        })
        let el = this.slides.shift();
        this.slides.push(el);
        this.getLeftPosition(1)
      
      },2000)
      
    })

    this.startMooving()
    
  }

  arrangeImges(){
    
    for(let i = 1; i<this.slides.length-1; i++){
        let el = this.slides[i];
        this.slides[i] = this.slides[this.slides.length-1]
        this.slides[this.slides.length-1] =el;

    }
  }
  startMooving(){
    this.idInterval = setInterval(()=>{
      this.next()
    },7000)
  }

}
